import { useSettings } from "utils/settingsContext";

/**
 * Custom hook to fetch provider payouts data.
 * @returns {{ providerPayouts: { [key: string]: string } }} - Object containing provider payout descriptions.
 */
export default function useGetProviderPayouts() {
  const { integratorSettings } = useSettings();
  // this will come from integrator settings if exist, else global setting
  // conditional logic is done at api layer
  const providerPayouts = integratorSettings.providerPayouts;
  return { providerPayouts };
}
